import {
    SettingBlockedActiveIcon, SettingCustomeSignActiveIcon, SettingGeneralActiveIcon, SettingLowCreditActiveIcon, SettingUnsubActiveIcon,
    SettingsBlockedIcon,
    SettingsCustomSignIcon,
    SettingsGeneralIcon,
    SettingsLowCreditNotifyIcon,
    SettingsNotificationActiveIcon, SettingsNotificationIcon,
    SettingsScheduledReportActiveIcon,
    SettingsScheduledReportIcon, SettingsUnsubscribedIcon, ComplianceMsgIcon, ComplianceMsgActiveIcon, AfterHoursDark, AfterHours,
    FeatureFlagInactive,
    FeatureflagActivesvg,
    APIAccessKeyInActiveIcon,
    APIAccessKeyActiveIcon

} from '../../icon';
import { PlanMetrics } from '../../models/plan-metrics.model';
import { SRouteModel } from "../../models/routes.model";
import { LocalStorage } from '../../services/UtilityService';
import { AppRoutes } from './route.path';

export const getSettingsRoutes = () => {
    const currentUser = LocalStorage.get("current-user")
    const isNewSubFlow = currentUser?.isNewSubFlow ?? false
    const routes: SRouteModel[] = [
        {
            id: 111,
            label: "General",
            path: AppRoutes.GENERAL,
            roles: [2, 3, 4],
            primaryIcon: SettingsGeneralIcon,
            primaryDarkIcon: SettingGeneralActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
        {
            id: 112,
            label: "Notifications",
            path: AppRoutes.NOTIFICATION_SETTINGS,
            roles: [2, 3, 4],
            primaryIcon: SettingsNotificationIcon,
            primaryDarkIcon: SettingsNotificationActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
        },

        {
            id: 113,
            label: "Blocked",
            path: AppRoutes.BLOCKED,
            roles: [2, 3, 4],
            primaryIcon: SettingsBlockedIcon,
            primaryDarkIcon: SettingBlockedActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
        {
            id: 114,
            label: "Unsubscribed",
            path: AppRoutes.UNSUBSCRIBE,
            roles: [2, 3, 4],
            primaryIcon: SettingsUnsubscribedIcon,
            primaryDarkIcon: SettingUnsubActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
        {
            id: 115,
            label: "Custom Signature",
            path: AppRoutes.SIGNATURE,
            roles: [2, 3, 4],
            primaryIcon: SettingsCustomSignIcon,
            primaryDarkIcon: SettingCustomeSignActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
            hide: isNewSubFlow && !currentUser?.userPlanTracker?.hasSignature
        },
        {
            id: 116,
            label: "Low Credit Notification",
            path: AppRoutes.LOW_CREDIT_NOTIFICATION,
            roles: [2],
            primaryIcon: SettingsLowCreditNotifyIcon,
            primaryDarkIcon: SettingLowCreditActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
            hide: isNewSubFlow
        },
        {
            id: 117,
            label: "Scheduled Report",
            path: AppRoutes.SCHEDULED_REPORT,
            roles: [2],
            primaryIcon: SettingsScheduledReportIcon,
            primaryDarkIcon: SettingsScheduledReportActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
        {
            id: 118,
            label: "After Hours",
            path: AppRoutes.AFTER_HOURS,
            roles: [2, 4],
            primaryIcon: AfterHours,
            primaryDarkIcon: AfterHoursDark,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
        {
            id: 119,
            label: "Compliance Message",
            path: AppRoutes.COMPLIANCE_MESSAGE,
            roles: [1, 2, 4],
            primaryIcon: ComplianceMsgIcon,
            primaryDarkIcon: ComplianceMsgActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
        {
            id: 120,
            label: "Feature Flags",
            path: AppRoutes.FEATURE_FLAG,
            roles: [2],
            primaryIcon: FeatureFlagInactive,
            primaryDarkIcon: FeatureflagActivesvg,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
        {
            id: 121,
            label: "API access",
            path: AppRoutes.API_ACCESS,
            roles: [2],
            primaryIcon: APIAccessKeyInActiveIcon,
            primaryDarkIcon: APIAccessKeyActiveIcon,
            authenticationRequired: true,
            isSettingsMenu: true,
        },
    ];
    return routes
}

export const getSettingsMenus = (role: number, planMetrics: PlanMetrics): SRouteModel[] => {
    return getSettingsRoutes().filter(route => route.isSettingsMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role)).filter(x => !x.hide);
}